export enum ModalSectionType {
	Create,
	Edit
}
